(() => {
  'use strict';
  if (window.OutpostNativeCart) return;
  let config = {};
  try { config = JSON.parse(document.querySelector('[data-native-cart-config]')?.textContent || '{}'); } catch (_) {}
  const copy = {...{
  "incomplete": "This selection is incomplete. Please remove it and add it again.",
  "detached": "An accessory is missing or no longer attached to this selection. Please remove the selection and add it again.",
  "mismatched": "The quantities in this selection do not match. Set the quantity again or remove the selection before checking out.",
  "unavailable": "Basket response unavailable",
  "update_failed": "The basket could not be updated.",
  "unconfirmed": "The basket update could not be confirmed.",
  "whole_number": "Please enter a whole-number quantity.",
  "updating": "Updating your basket…",
  "changed": "The selection changed while updating. Please review your basket.",
  "quantity_unconfirmed": "The quantity change could not be confirmed. Please review your basket.",
  "timed_out": "The connection timed out.",
  "review": "Please check the quantity and try again, or remove this selection.",
  "refresh_totals": "Refresh your basket to see its latest totals.",
  "refresh": "Refresh basket",
  "artwork_not_ready": "Artwork checking is not ready. Please refresh the page and try again.",
  "check_failed": "We could not check your basket. Please try again."
}, ...config.messages};
  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = (config.cartUrl || root + 'cart').replace(/\.js$/, '');
  const noticeKey = 'outpost-native-cart-notice';
  let busy = false, busyGroup = null, checking = false, approvedForm = null;
  const groupId = item => item.properties?._outpost_group;
  const groupItems = (cart, id) => cart.items.filter(item => groupId(item) === id);
  const expectedIds = parent => parent.properties._outpost_components === 'none' ? [] : parent.properties._outpost_components.split(',').sort();
  const sameIds = (a, b) => a.length === b.length && a.every((id, index) => id === b[index]);
  const validGroupId = id => typeof id === 'string' && id.trim().length > 0;
  const structure = (items, cart) => {
    const parents = items.filter(item => item.properties?._outpost_role === 'parent');
    if (parents.length !== 1) return copy.incomplete;
    if (items.some(item => typeof item.key !== 'string' || !item.key || !/^[1-9]\d*$/.test(String(item.variant_id || item.id)))) return copy.incomplete;
    const parent = parents[0], children = items.filter(item => item !== parent);
    const manifest = parent.properties._outpost_components;
    if (typeof manifest !== 'string' || (manifest !== 'none' && !/^[1-9]\d*(,[1-9]\d*)*$/.test(manifest))) return copy.detached;
    const expected = expectedIds(parent);
    if (new Set(expected).size !== expected.length || parent.parent_relationship?.parent_key ||
        children.some(item => item.properties?._outpost_role !== 'accessory') ||
        !sameIds(expected, children.map(item => String(item.variant_id || item.id)).sort()) ||
        children.some(item => item.parent_relationship?.parent_key !== parent.key) ||
        cart?.items.some(item => item.parent_relationship?.parent_key === parent.key && !children.includes(item))) {
      return copy.detached;
    }
    return '';
  };
  const validate = cart => {
    if (!Array.isArray(cart?.items)) throw new Error(copy.unavailable);
    const ungrouped = cart.items.some(item => !validGroupId(groupId(item)) && (item.properties?._outpost_role || item.properties?._outpost_components));
    const problems = ungrouped ? [{group: null, message: copy.incomplete}] : [];
    return problems.concat([...new Set(cart.items.map(groupId).filter(validGroupId))].flatMap(id => {
      const items = groupItems(cart, id), problem = structure(items, cart);
      const parent = items.find(item => item.properties?._outpost_role === 'parent');
      const message = problem || (items.some(item => !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.quantity !== parent.quantity) ? copy.mismatched : '');
      return message ? [{group: id, message}] : [];
    }));
  };
  const fingerprint = cart => JSON.stringify({
    total: cart.total_price ?? null, currency: cart.currency ?? null,
    items: cart.items.map(item => [item.key, item.variant_id || item.id, item.quantity, item.final_line_price ?? null,
      item.properties?._outpost_group ?? null, item.properties?._outpost_role ?? null, item.properties?._outpost_components ?? null,
      item.parent_relationship?.parent_key ?? null]).sort((a, b) => String(a[0]).localeCompare(String(b[0])))
  });
  let renderedFingerprint = Array.isArray(config.cart?.items) ? fingerprint(config.cart) : null;
  const request = async (path, body) => {
    const abort = new AbortController(), timer = setTimeout(() => abort.abort(), 20000);
    try {
      const response = await fetch(cartUrl + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: abort.signal,
        headers: body ? {'Content-Type': 'application/json', 'Accept': 'application/json'} : {'Accept': 'application/json'},
        ...(body ? {body: JSON.stringify(body)} : {})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || copy.update_failed);
      if (!Array.isArray(result.items)) throw new Error(copy.unconfirmed);
      return result;
    } finally { clearTimeout(timer); }
  };
  const currentCart = () => request('.js');
  const accessoryProperties = new Set(['Wooden handle', 'Add electric heater', 'Hammering handle', 'Hot stamping machine adaptor kit']);
  const checkoutProperties = item => Object.fromEntries(Object.entries(item.properties || {}).filter(([name]) =>
    !(item.properties?._outpost_role === 'parent' && validGroupId(groupId(item)) && accessoryProperties.has(name))));
  const needsCheckoutCleanup = item => Object.keys(checkoutProperties(item)).length !== Object.keys(item.properties || {}).length;
  const checkoutContents = cart => {
    const identity = item => validGroupId(groupId(item)) ? [groupId(item), item.properties._outpost_role, item.variant_id || item.id] : [item.key];
    return JSON.stringify({
      total: cart.total_price, currency: cart.currency, count: cart.item_count,
      note: cart.note ?? null, attributes: cart.attributes ?? {},
      items: cart.items.map(item => {
        const parentKey = item.parent_relationship?.parent_key;
        const parent = parentKey && cart.items.find(row => row.key === parentKey);
        return [identity(item), item.quantity, item.final_line_price,
          Object.entries(checkoutProperties(item)).sort(([a], [b]) => a.localeCompare(b)),
          parent ? identity(parent) : parentKey || null];
      }).sort((a, b) => JSON.stringify(a[0]).localeCompare(JSON.stringify(b[0])))
    });
  };
  const cleanCheckoutProperties = async cart => {
    const groups = cart.items.filter(needsCheckoutCleanup).map(groupId);
    if (!groups.length) return cart;
    const contents = checkoutContents(cart);
    let latest = cart;
    for (const id of groups) {
      latest = await currentCart();
      if (validate(latest).length || checkoutContents(latest) !== contents) throw new Error(copy.changed);
      const parent = groupItems(latest, id).find(item => item.properties._outpost_role === 'parent');
      if (!parent) throw new Error(copy.changed);
      if (!needsCheckoutCleanup(parent)) continue;
      latest = await request('/change.js', {id: parent.key, quantity: parent.quantity, properties: checkoutProperties(parent)});
      if (validate(latest).length || checkoutContents(latest) !== contents) throw new Error(copy.changed);
      const updated = groupItems(latest, id).find(item => item.properties._outpost_role === 'parent');
      if (!updated || needsCheckoutCleanup(updated)) throw new Error(copy.unconfirmed);
      document.querySelectorAll('[data-artwork-cart-line]').forEach(panel => {
        if (panel.dataset.lineKey === parent.key) panel.dataset.lineKey = updated.key;
      });
    }
    latest = await currentCart();
    if (validate(latest).length || checkoutContents(latest) !== contents || latest.items.some(needsCheckoutCleanup)) throw new Error(copy.changed);
    return latest;
  };
  const message = (id, text, error = true) => {
    let panels = [...document.querySelectorAll('[data-native-cart-group]')].filter(panel => !id || panel.dataset.nativeCartGroup === id);
    panels.forEach(panel => {
      const target = panel.querySelector('[data-native-cart-message]');
      if (!target) return;
      target.textContent = text; target.hidden = !text;
      target.classList.toggle('ow-cart-error', Boolean(text && error));
      target.setAttribute('role', error ? 'alert' : 'status');
      panel.classList.toggle('ow-cart-invalid', Boolean(text && error));
    });
    if (!panels.length && text) {
      const container = document.querySelector('.cart-header, .cart-drawer__top, .cart-order, main') || document.body;
      let target = container.querySelector('[data-native-cart-global-error]');
      if (!target) { target = document.createElement('p'); target.className = 'ow-cart-error text-sm'; target.dataset.nativeCartGlobalError = ''; target.setAttribute('role', 'alert'); target.tabIndex = -1; container.append(target); }
      target.textContent = text; target.hidden = false;
      target.classList.toggle('ow-cart-error', error);
    }
  };
  const revealProblem = (panel, message) => {
    if (!panel || !message) return;
    message.setAttribute('tabindex', '-1');
    message.focus({preventScroll:true});
    const frame = window.requestAnimationFrame || (callback => setTimeout(callback, 0));
    frame(() => frame(() => {
      if (!panel.isConnected || panel.hidden || !message.isConnected || message.hidden) return;
      const viewport = window.visualViewport;
      const viewportTop = viewport?.offsetTop || 0;
      const viewportHeight = viewport?.height || window.innerHeight;
      let scroller = panel.parentElement;
      while (scroller && scroller !== document.body && scroller !== document.documentElement) {
        if (/(auto|scroll)/.test(getComputedStyle(scroller).overflowY) && scroller.scrollHeight > scroller.clientHeight) break;
        scroller = scroller.parentElement;
      }
      if (scroller === document.body || scroller === document.documentElement) scroller = null;
      const header = document.querySelector('.shopify-section--header');
      const headerHeight = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position) ? Math.max(0, header.getBoundingClientRect().bottom - viewportTop) : 0;
      const previewBar = document.getElementById('PBarNextFrameWrapper');
      const previewRect = previewBar?.getBoundingClientRect();
      const bottomInset = previewRect?.height && getComputedStyle(previewBar).position === 'fixed' ? Math.max(0, viewportTop + viewportHeight - previewRect.top) : 0;
      const scrollRect = scroller?.getBoundingClientRect();
      const top = scroller ? Math.max(viewportTop, scrollRect.top) + 16 : viewportTop + headerHeight + 16;
      const bottom = scroller ? Math.min(viewportTop + viewportHeight, scrollRect.bottom) - 16 : viewportTop + viewportHeight - bottomInset - 16;
      const available = Math.max(0, bottom - top);
      const rect = panel.getBoundingClientRect();
      const messageRect = message.getBoundingClientRect();
      const destination = rect.height <= available ? top + (available - rect.height) / 2 : top;
      let delta = rect.top - destination;
      if (messageRect.bottom - delta > bottom) delta = messageRect.bottom - bottom;
      if (messageRect.top - delta < top) delta = messageRect.top - top;
      if (Math.abs(delta) > 1) (scroller || window).scrollTo({top:Math.max(0,(scroller ? scroller.scrollTop : window.scrollY) + delta),behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
  };
  const visibleProblem = element => {
    if (!element || element.hidden || element.closest('[hidden], [inert], [aria-hidden="true"]') || !element.getClientRects().length) return false;
    if (element.checkVisibility && !element.checkVisibility({visibilityProperty:true})) return false;
    return !['hidden', 'collapse'].includes(getComputedStyle(element).visibility);
  };
  const focusProblem = () => {
    const target = [...document.querySelectorAll('[data-native-cart-message]:not([hidden]), [data-native-cart-global-error]:not([hidden])')].find(visibleProblem);
    if (target) revealProblem(target.closest('[data-native-cart-group]') || target, target);
  };
  const showProblems = cart => {
    document.querySelectorAll('[data-native-cart-message], [data-native-cart-global-error]').forEach(element => { element.textContent = ''; element.hidden = true; });
    document.querySelectorAll('.ow-cart-invalid').forEach(element => element.classList.remove('ow-cart-invalid'));
    const problems = validate(cart);
    problems.forEach(problem => message(problem.group, problem.message));
    return problems;
  };
  const controlSelector = '[data-native-cart-quantity], [data-native-cart-remove]';
  const enableControls = () => {
    document.querySelectorAll(controlSelector).forEach(element => { element.disabled = busy; });
  };
  const setBusy = (state, id = null) => {
    busy = state;
    busyGroup = state ? id : null;
    document.querySelectorAll('[data-native-cart-group]').forEach(element => {
      element.setAttribute('aria-busy', String(state));
      const loader = element.querySelector('pill-loader');
      if (!loader) return;
      const updateLoader = () => {
        if (!loader.isConnected) return;
        if (busy && element.dataset.nativeCartGroup === busyGroup) loader.setAttribute('aria-busy', 'true');
        else if (loader.hasAttribute('aria-busy')) loader.removeAttribute('aria-busy');
      };
      if (customElements.get('pill-loader')) updateLoader();
      // The theme builds the loader's dots when its custom element is connected.
      else if (state && element.dataset.nativeCartGroup === id) customElements.whenDefined('pill-loader').then(updateLoader);
    });
    enableControls();
  };
  const reload = () => { window.location.assign(cartUrl); };
  const sectionContext = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles: true, detail: {sections}}));
    const main = document.querySelector('.shopify-section--main-cart');
    const mainId = main?.id.replace(/^shopify-section-/, '');
    if (mainId) sections.push(mainId);
    const ids = [...new Set(sections)].filter(Boolean);
    if (!ids.length || ids.length > 5) throw new Error('Unexpected cart section count: ' + ids.join(','));
    const drawer = document.querySelector('cart-drawer');
    const drawerId = drawer?.closest('.shopify-section')?.id.replace(/^shopify-section-/, '');
    return {ids, main, mainId, drawerId};
  };
  const parseSections = (rendered, {ids, main, mainId, drawerId}) => {
    if (!rendered || typeof rendered !== 'object' || Array.isArray(rendered)) throw new Error('Invalid section response');
    const missingIds = ids.filter(id => typeof rendered[id] !== 'string' || !rendered[id].trim());
    if (missingIds.length) throw new Error('Section HTML unavailable: ' + missingIds.join(',') + '; returned: ' + Object.keys(rendered).join(','));
    const parsed = new Map(ids.map(id => [id, new DOMParser().parseFromString(rendered[id], 'text/html')]));
    if (mainId && !parsed.get(mainId).getElementById(main.id)) throw new Error('Main section wrapper missing: ' + main.id);
    if (drawerId && !parsed.get(drawerId)?.querySelector('cart-drawer')) throw new Error('Drawer section wrapper missing: ' + drawerId);
    return parsed;
  };
  const sectionSnapshot = section => {
    const snapshots = section.querySelectorAll('script[data-native-cart-snapshot]');
    if (snapshots.length !== 1) throw new Error('Basket section snapshot unavailable');
    return JSON.parse(snapshots[0].textContent);
  };
  const validateSections = (parsed, {drawerId}, cart, requireSnapshot) => {
    if (drawerId && cart.items.length && !parsed.get(drawerId).querySelector('.cart-drawer__inner')) throw new Error('Drawer contents missing: ' + drawerId);
    if (drawerId && cart.items.length && !parsed.get(drawerId).querySelector('[slot="footer"]')) throw new Error('Drawer footer missing: ' + drawerId);
    if (requireSnapshot && [...parsed.values()].some(section => fingerprint(sectionSnapshot(section)) !== fingerprint(cart))) throw new Error('Section snapshot does not match confirmed basket');
  };
  const completeSnapshot = cart => {
    const money = value => Number.isSafeInteger(value) && value >= 0;
    const object = value => value && typeof value === 'object' && !Array.isArray(value);
    return object(cart) && money(cart.total_price) && money(cart.item_count) && /^[A-Z]{3}$/.test(cart.currency) &&
      Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.every(discount => object(discount) && money(discount.total_allocated_amount)) &&
      Array.isArray(cart.items) && cart.items.every(item => object(item) && typeof item.key === 'string' && item.key &&
        Number.isSafeInteger(item.variant_id) && item.variant_id > 0 && Number.isSafeInteger(item.quantity) && item.quantity > 0 &&
        money(item.final_line_price) && typeof item.requires_shipping === 'boolean' && object(item.properties) &&
        (item.parent_relationship === null || object(item.parent_relationship) && typeof item.parent_relationship.parent_key === 'string' && item.parent_relationship.parent_key)) &&
      new Set(cart.items.map(item => item.key)).size === cart.items.length &&
      cart.items.reduce((total, item) => total + item.quantity, 0) === cart.item_count;
  };
  const cartFromSections = rendered => {
    try {
      const context = sectionContext(), parsed = parseSections(rendered, context);
      const snapshots = [...parsed.values()].map(sectionSnapshot), cart = snapshots[0];
      if (!completeSnapshot(cart) || validate(cart).length || snapshots.some(snapshot => JSON.stringify(snapshot) !== JSON.stringify(cart))) return null;
      validateSections(parsed, context, cart, false);
      return cart;
    } catch (_) { return null; }
  };
  const refresh = async (cart, bundledSections) => {
    const context = sectionContext(), {ids, main, mainId} = context;
    let rendered = bundledSections, parsed;
    if (bundledSections) {
      try {
        const bundled = parseSections(bundledSections, context);
        validateSections(bundled, context, cart, true);
        parsed = bundled;
      } catch (_) {}
    }
    if (!parsed) {
      const url = new URL(cartUrl, window.location.origin);
      url.searchParams.set('sections', ids.join(','));
      const abort = new AbortController(), timer = setTimeout(() => abort.abort(), 20000);
      try {
        const response = await fetch(url.href, {credentials: 'same-origin', cache: 'no-store', signal: abort.signal});
        if (!response.ok) throw new Error('Section request failed: ' + response.status);
        rendered = await response.json();
      } finally { clearTimeout(timer); }
      parsed = parseSections(rendered, context);
      validateSections(parsed, context, cart, false);
      const confirmed = await currentCart();
      if (fingerprint(confirmed) !== fingerprint(cart)) throw new Error('Basket changed while rendering sections');
    }
    if (mainId) main.replaceChildren(...parsed.get(mainId).getElementById(main.id).childNodes);
    cart.sections = rendered;
    renderedFingerprint = fingerprint(cart);
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true, detail: {baseEvent: 'quantity:change', cart}}));
    await new Promise(resolve => setTimeout(resolve, 0));
    showProblems(cart);
  };
  const finishChange = async cart => {
    try { await refresh(cart); } catch (_) { reload(); }
  };
  const changeGroup = async (id, quantity) => {
    if (busy || checking) return;
    if (!Number.isSafeInteger(quantity) || quantity < 0) { message(id, copy.whole_number); focusProblem(); return; }
    setBusy(true, id); message(id, '', false);
    let latest;
    try {
      latest = await currentCart();
      let items = groupItems(latest, id);
      if (!items.length) { await finishChange(latest); return; }
      if (quantity > 0 && structure(items, latest)) throw new Error(structure(items, latest));
      // change.js checks stock; update.js explicitly does not check existing stock.
      // Refresh keys from each response because discounts and properties can change them.
      const parent = items.find(item => item.properties?._outpost_role === 'parent');
      const identities = (parent ? [parent, ...items.filter(item => item !== parent)] : items).map(item => ({role: item.properties._outpost_role, variant: String(item.variant_id || item.id)}));
      for (const identity of identities) {
        items = groupItems(latest, id);
        if (quantity > 0 && structure(items, latest)) throw new Error(structure(items, latest));
        const item = items.find(row => row.properties._outpost_role === identity.role && String(row.variant_id || row.id) === identity.variant);
        // Removing a nested parent also removes all its children on Shopify.
        if (!item && quantity === 0) continue;
        if (!item) throw new Error(copy.changed);
        if (typeof item.key !== 'string' || !item.key) throw new Error(copy.changed);
        if (item.quantity === quantity) continue;
        latest = await request('/change.js', {id: item.key, quantity});
      }
      latest = await currentCart();
      items = groupItems(latest, id);
      if (quantity === 0 ? items.length !== 0 : !items.length || structure(items, latest) || items.some(item => item.quantity !== quantity)) throw new Error(copy.quantity_unconfirmed);
      await finishChange(latest);
    } catch (error) {
      let reconciled = false;
      try {
        latest = await currentCart();
        reconciled = true;
        const items = groupItems(latest, id);
        const confirmed = quantity === 0 ? !items.length : items.length && !structure(items, latest) && items.every(item => item.quantity === quantity);
        if (confirmed) { await finishChange(latest); return; }
        showProblems(latest);
        const parent = items.find(item => item.properties?._outpost_role === 'parent');
        document.querySelectorAll('[data-native-cart-quantity]').forEach(input => { if (input.dataset.nativeCartQuantity === id && parent) input.value = parent.quantity; });
      } catch (_) { /* Leave the selection visible; checkout always verifies again. */ }
      const errorMessage = (error.name === 'AbortError' ? copy.timed_out : error.message) + ' ' + copy.review;
      // Show Shopify's confirmed totals after a partial update, with a one-time
      // explanation. Storage is optional; a blocked storage API must not block edits.
      if (reconciled) {
        try { sessionStorage.setItem(noticeKey, JSON.stringify({id, message: errorMessage})); reload(); return; } catch (_) { /* Render recovery below. */ }
      }
      message(id, errorMessage + ' ' + copy.refresh_totals);
      const panel = [...document.querySelectorAll('[data-native-cart-group]')].find(element => element.dataset.nativeCartGroup === id);
      const target = panel?.querySelector('[data-native-cart-message]');
      if (target) {
        const link = document.createElement('a'); link.href = cartUrl; link.className = 'link'; link.textContent = ' ' + copy.refresh; target.append(link);
      }
    } finally { setBusy(false); }
  };
  const check = async () => {
    if (busy || checking) return false;
    const invalidQuantity = [...document.querySelectorAll('[data-native-cart-quantity]')].find(input => !input.disabled && visibleProblem(input) && (!input.validity.valid || !Number.isSafeInteger(Number(input.value)) || Number(input.value) < 1));
    if (invalidQuantity) {
      message(invalidQuantity.dataset.nativeCartQuantity, copy.whole_number);
      focusProblem();
      return false;
    }
    checking = true;
    try {
      const cart = await currentCart();
      if (showProblems(cart).length) return false;
      if (renderedFingerprint && fingerprint(cart) !== renderedFingerprint) {
        await finishChange(cart);
        message(null, copy.changed);
        return false;
      }
      if (document.querySelector('[data-artwork-cart-line]')) {
        if (!window.OutpostArtworkCart?.check) { message(null, copy.artwork_not_ready); return false; }
        if (!await window.OutpostArtworkCart.check(true)) return false;
        const confirmed = await currentCart();
        if (showProblems(confirmed).length) return false;
        if (fingerprint(confirmed) !== fingerprint(cart)) {
          await finishChange(confirmed);
          message(null, copy.changed);
          return false;
        }
      }
      const cleaned = await cleanCheckoutProperties(cart);
      renderedFingerprint = fingerprint(cleaned);
      return true;
    } catch (_) { message(null, copy.check_failed); return false; }
    finally { checking = false; }
  };
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-native-cart-quantity]');
    if (!input) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!input.checkValidity()) { message(input.dataset.nativeCartQuantity, copy.whole_number); focusProblem(); return; }
    changeGroup(input.dataset.nativeCartQuantity, Number(input.value));
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-native-cart-remove]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    changeGroup(button.dataset.nativeCartRemove, 0);
  }, true);
  document.addEventListener('submit', async event => {
    if (event.submitter?.name !== 'checkout' || approvedForm === event.target) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy || checking) return;
    const form = event.target, button = event.submitter;
    button.setAttribute('aria-busy', 'true');
    const valid = await check();
    button.removeAttribute('aria-busy');
    if (valid && button.isConnected) {
      approvedForm = form;
      try { form.requestSubmit(button); } finally { approvedForm = null; }
    } else focusProblem();
  }, true);
  window.OutpostNativeCart = Object.freeze({validate, check, changeGroup, refresh, cartFromSections, revealProblem});
  document.addEventListener('cart:change', event => {
    if (Array.isArray(event.detail?.cart?.items)) renderedFingerprint = fingerprint(event.detail.cart);
  });
  enableControls();
  if (Array.isArray(config.cart?.items)) showProblems(config.cart);
  try {
    const notice = JSON.parse(sessionStorage.getItem(noticeKey) || 'null');
    sessionStorage.removeItem(noticeKey);
    if (notice && typeof notice.message === 'string') message(notice.id, notice.message);
  } catch (_) { /* Storage may be blocked in private browsing. */ }
  // Drawer sections are replaced by the theme after add-to-cart and normal edits.
  // Only inspect inserted subtrees; upload progress and unrelated page changes
  // must not repeatedly scan every cart control in the document.
  const insertedControls = new Set();
  let controlsQueued = false;
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches(controlSelector)) insertedControls.add(node);
      node.querySelectorAll(controlSelector).forEach(control => insertedControls.add(control));
    }));
    if (!insertedControls.size || controlsQueued) return;
    controlsQueued = true;
    queueMicrotask(() => {
      controlsQueued = false;
      insertedControls.forEach(control => { if (control.isConnected) control.disabled = busy; });
      insertedControls.clear();
    });
  }).observe(document.documentElement, {childList: true, subtree: true});
})();

